getNewRelicLibrary